mutation RequestImport2Sponsorship($input: ImportRequestSponsorshipInput!) {
    import2RequestSponsorship(input: $input) {
        import {
            originId
        }
    }
}
